<template>
  <div>
    <h3 style="border-bottom: 1px solid #D7D7D7;color: #666666;font-size: 28px;padding-bottom: 20px;margin-bottom: 30px;">
      产品中心
    </h3>
    <el-alert
      style="text-align: left"
      show-icon
      title="注意"
      type="info"
      description="新增有类型有：产品功能、使用介绍、Android二维码、IOS二维码 四种类型，如果四种类型已经存在，请直接修改">
    </el-alert>
    <el-button type="primary"
               @click="dialogFormVisible = true; form={ head: 'text'};fileList=[];"
               style="float:left;"
               plain>新增</el-button>
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%">
      <el-table-column
        prop="head"
        label="标题（界面展示）">
      </el-table-column>
      <el-table-column width="400px"
                       prop="description"
        label="描述">
        <template slot-scope="scope">
          <span v-html="scope.row.description"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="headEn"
        label="类型（用于区分数据类型）">
        <template slot-scope="scope">
          {{productModule[scope.row.headEn]}}
        </template>
      </el-table-column>
      <el-table-column
        prop="image"
        label="图片">
        <template slot-scope="scope">
          <img :src="common.getPictureUrl(scope.row)" style="height: 120px;">
        </template>
      </el-table-column>
      <el-table-column
        prop="sequence"
        sortable
        label="排序">
      </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
        </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog title="添加图片" :visible.sync="dialogFormVisible" width="35%">
      <el-form ref="form" :model="form" label-width="120px" >
        <el-form-item label="类型">
            <el-select v-model="form.headEn" placeholder="请选择类型" :change="hideItem()" :value="form.headEn">
              <el-option v-for="(val, key, index) in productModule" :label="val" :value="key"></el-option>
            </el-select>
          <!--<el-radio-group v-model="form.head"-->
                          <!--:change="hideItem()"-->
          <!--&gt;-->
            <!--<el-radio label="text" >文本</el-radio>-->
            <!--<el-radio label="Android">Android</el-radio>-->
            <!--<el-radio label="IOS">IOS</el-radio>-->
          <!--</el-radio-group>-->
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="form.head"></el-input>
        </el-form-item>
        <el-form-item label="描述" :style='hideOption.description'>
          <vue-editor v-model="form.description"
                      useCustomImageHandler
                      @imageAdded="this.$common.handleImageAdded">
          </vue-editor>
        </el-form-item>
        <el-form-item label="二维码"
                      :style='hideOption.image'
                      :label-width="formLabelWidth">
          <el-upload
            :action="this.$host+'upload'"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :limit="1"
            :file-list="fileList"
            :on-success="uploadAndroid"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">提交</el-button>
      </div>
    </el-dialog>



  </div>
</template>

<script>
  import { VueEditor } from 'vue2-editor'

  export default {
    name: "Settings",
    components: {
      VueEditor,
    },
    data() {
      return {
        tableData:[],
        dialogFormVisible:false,
        form: {},
        formLabelWidth: '120px',
        fileList:[],
        dialogVisible:false,
        dialogImageUrl : '',
        hideOption:{},
        common:this.$common,
        productModule:{
          IOS:'IOS二维码',
          Android:'Android二维码',
          introduction:'产品功能',
          usage:'使用介绍',
        },
      }
    },
    methods: {
      hideItem(){
        console.log("this.form" + JSON.stringify(this.form))
        this.hideOption.image = {}
        this.hideOption.description = {}
        if('introduction' === this.form.headEn ||
          'usage'=== this.form.headEn){
          this.hideOption.image = {display: 'none'}
        }
        if('Android'===this.form.headEn ||
          'IOS'=== this.form.headEn){
          this.hideOption.description = {display: 'none'}
        }
      },
      submit() {
        const self = this
        this.form.type='product'
        let postData = self.$qs.stringify(this.form)
        let method = 'save'
        if(self.form.id){
          method = 'update'
        }
        self.$http.post(self.$host+'content/'+method,
          postData
        ).then(function (response) {
          self.$common.loginCheck(response.data.content)
          self.dialogFormVisible = false
          self.loadData()
        }).catch(e => {
          console.log(e)
        })
      },
      loadData(params) {
        const self = this
        let postData =
          self.$qs.stringify({
            'type':'product',
          })
        self.$http.post(self.$host+'content/list',
          postData
        ).then(function (response) {
          console.log(response.data)
          self.tableData = response.data.content;
        }).catch(e => {
          console.log(e)
        })
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      uploadAndroid(response,file, fileList) {
        this.form.image = response.content;
      },
      handleEdit(row){
        // 这里需要把row的数据拷贝一份，不然在编辑栏编辑的时候回改动列表的数据
        this.form = {}
        this.form = JSON.parse(JSON.stringify(row))
        this.imageUrl = row.image

        this.dialogFormVisible = true;
      },
      handleDelete(row){
        this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const self = this
          let postData = self.$qs.stringify(row)
          self.$http.post(self.$host+'content/delete',
            postData
          ).then(function (response) {
            self.$common.loginCheck(response.data.content)
            self.tableData = response.data.list;
            self.dialogFormVisible = false
            self.loadData()
          }).catch(e => {
            console.log(e)
          })
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    },
    mounted(){
      this.$nextTick(() => {
        this.hideItem()
        this.loadData();
      })
    },
  }
</script>

<style scoped>
  .el-form{
    width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/ProductManage.vue